import columns from '../../../../react-table/helpers/columns';

export const statusConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.status === 'SAVED') {
      className = 'bg-amber';
    } else if ((rowInfo.row.status === 'OPEN') || (rowInfo.row.status === 'SERVICED_OUT') || (rowInfo.row.status === 'SERVICED_IN')) {
      className = 'bg-green';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredNonZeroNumberColumn,
    FilteredDateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredNonZeroNumberColumn('Transaction id', 'id').withShow(false),
        new FilteredTextColumn('Outbound Operator', 'operatorFrom').withGetProps(statusConditionalProps),
        new FilteredTextColumn('Outbound IMPC', 'impcFrom').withGetProps(statusConditionalProps),
        new FilteredTextColumn('Inbound Operator', 'operatorTo').withGetProps(statusConditionalProps),
        new FilteredTextColumn('Inbound IMPC', 'impcTo').withGetProps(statusConditionalProps),
        new FilteredNonZeroNumberColumn('Quantity', 'quantity').withGetProps(statusConditionalProps),
        new FilteredDateTimeColumn('Planned Departure date & time', 'departureDate').withGetProps(statusConditionalProps),
        new FilteredDateTimeColumn('Planned Arrival date & time', 'arrivalDate').withGetProps(statusConditionalProps),
        new FilteredTextColumn('User', 'lastUpdateUser').withGetProps(statusConditionalProps),
        new FilteredTextColumn('Comments', 'comments').withGetProps(statusConditionalProps),
        new FilteredTextColumn('Status', 'status').withGetProps(statusConditionalProps),
        new FilteredDateTimeColumn('Last Updated', 'lastUpdateDate').withGetProps(statusConditionalProps),
      ],
    },
  ];
};
